/**
 * Transforms email to possible name i.e.
 * sergey.mell@agilie.com => Sergey Mell
 * @param email
 */
export function emailToName(email: string): string {
    const prefix = email.split('@')[0];
    const name = prefix
        .replace(/\d/, '')
        .split(/[.]/)
        .filter(v => !!v)
        .map(chunk => capitalize(chunk))
        .join(' ');
    if (name.length < 3) {
        return 'Guest';
    } else {
        return name;
    }
}

function capitalize(str: string): string {
    if (!str) {
        return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}
